export const GET_ALL_CLIENTS = 'GET_ALL_CLIENTS';
export const GET_CLIENT_INFO = 'GET_CLIENT_INFO';
export const GET_CLIENT_PENDIND_INVITE = 'GET_CLIENT_PENDIND_INVITE';
export const GET_PUBLISHERS = 'GET_PUBLISHERS';
